<div id="logs">
    <h1 class="mb-4">
        <i class="fa fa-book"></i>
        <span>Registros</span>
    </h1>

    <div id="logs-filters" class="mb-3">
        <div id="logs-filter-event" class="me-3">
            <p class="fw-bold">Filtrar por evento:</p>
            <select name="logs-filter-event" id="logs-filter-event" [(ngModel)]="event">
                <option value="">Ninguno</option>
                <option *ngFor="let event of events" [value]="event">
                    {{ event }}
                </option>
            </select>
        </div>
        <div id="logs-filter-user" class="me-3">
            <p class="fw-bold">Filtrar por usuario:</p>
            <select name="logs-filter-user" id="logs-filter-user" [(ngModel)]="user">
                <option value="0">Ninguno</option>
                <option *ngFor="let user of users" [value]="user.id">
                    {{ user.firstname }} {{ user.lastname }}
                </option>
            </select>
        </div>
        <div id="logs-filter-date">
            <p class="fw-bold">Filtrar por fechas:</p>
            <input type="date" class="me-3" [(ngModel)]="start">
            <input type="date" class="me-3" [(ngModel)]="end">
        </div>
        <button id="log-search-btn" class="btn btn-primary" (click)="getLogs()">
            <i class="fas fa-search"></i>
        </button>
    </div>

    <div id="logs-loading" *ngIf="this.state == 'loading'">
        <i class="fas fa-spinner fa-spin"></i>
        <span>Cargando...</span>
    </div>

    <div id="logs-error" class="text-danger" *ngIf="this.state == 'error'">
        <i class="fas fa-times"></i>
        <span>Error</span>
    </div>

    <div id="logs-empty" *ngIf="this.state != 'loading' && logs.length == 0">
        <p>No hay registros.</p>
    </div>
    
    <div id="logs-container" *ngIf="logs.length > 0">
        <p class="fw-bold">Total eventos: {{ logs.length }}</p>
        <table id="logs-table" class="table">
            <thead>
                <tr>
                    <th>Evento</th>
                    <th>Usuario</th>
                    <th>Objeto</th>
                    <th>Fecha</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let log of logs">
                    <td>{{ log.event }}</td>
                    <td>{{ log.username }}</td>
                    <td>{{ log.object }}</td>
                    <td>{{ log.time }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>